export default {
  sm: `
  로고・BI 가이드
  다운로드
  `,
  md: `
  로고・BI 가이드 다운로드
  `
};
